document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('#to-stores');
    if (!section) return;

    const searchInput = document.getElementById("citySearch");
    const cityItems = document.querySelectorAll(".selectCity:not(.all-city)");

    if (searchInput) {
        searchInput.addEventListener("input", function () {
            const searchValue = searchInput.value.toLowerCase();

            cityItems.forEach(function (item) {
                const cityName = item.textContent.toLowerCase();
                if (cityName.includes(searchValue)) {
                    item.classList.remove("uk-hidden");
                } else {
                    item.classList.add("uk-hidden");
                }
            });
        });
    }

    let selectedWindow = document.querySelector(".selector-custom__selected>span"),
        table = document.querySelector(".availability-section__table"),
        hiddenInfo = document.querySelector(".hidden-info");

    document.querySelectorAll(".selectCity").forEach(element => {
        element.addEventListener("click", function (e) {
            e.preventDefault();
            let showAllButton = document.querySelector("#showAllStore");
            if (showAllButton && showAllButton.offsetParent !== null) {
                if (showAllButton.getAttribute("aria-expanded") === "false") {
                    showAllButton.click();
                }
                showAllButton.classList.add("uk-hidden");
                table.classList.remove("hidden-block");

                if(hiddenInfo){
                    hiddenInfo.classList.add("uk-hidden");
                }
            }

            if (this.classList.contains("all-city")) {
                selectedWindow.textContent = this.dataset.text;
                showAllButton.classList.remove("uk-hidden");
                table.classList.add("hidden-block");
                if(hiddenInfo) {
                    hiddenInfo.classList.remove("uk-hidden");
                }
                setTimeout(() => showAllButton.click(), 10);
            } else {
                selectedWindow.textContent = this.textContent.trim();

                const match = this.getAttribute("uk-filter-control").match(/data-city=['"](.+?)['"]/);
                const cityTag = match ? match[1] : null;
                document.querySelectorAll(`tr[data-city='${cityTag}']`).forEach(tr => {
                        tr.classList.remove("uk-hidden", "hidden-block-desc", "hidden-block-mob");
                });
            }

            const drop = UIkit.drop(
                document.querySelector(".selector-custom__dropdown")
            );
            drop.hide(0);
        });
    });
    document.querySelectorAll(".contact-title").forEach(item => {
        item.addEventListener("click", function () {
            document.querySelectorAll("tr.active").forEach(tr => tr.classList.remove("active"));
            this.closest("tr").classList.add("active");
        });
    });

    const input = document.getElementById('citySearch');
    const clearBtn = document.querySelector('.form-clear');

    if (!input || !clearBtn) {
        return;
    }

    clearBtn.style.display = 'none';

    input.addEventListener('input', () => {
        clearBtn.style.display = input.value ? 'block' : 'none';
    });

    clearBtn.addEventListener('click', () => {
        input.value = '';
        clearBtn.style.display = 'none';
        input.dispatchEvent(new Event('input'));
    });

    const btn = document.querySelector('.btn-open-video');
    const slider = document.querySelector('.mainProductSlider');
    if (!btn || !slider) return;
    let lastSlideIndex = 0;
    btn.addEventListener('click', function (e) {
        e.preventDefault();
        const swiper = slider.swiper;
        if (!swiper) return;
        lastSlideIndex = swiper.activeIndex;
        const videoLink = slider.querySelector('.slide-video a');
        if (videoLink) videoLink.click();
    });
});

function getScrollParam() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('scroll');
}
function scrollToElement(selector, offset = 100) {
    const element = document.querySelector(selector);
    if (element) {
        const targetPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
        return true;
    }
    return false;
}
window.addEventListener('load', function() {
    const scrollTarget = getScrollParam();
    if (scrollTarget) {
        const selector = scrollTarget.startsWith('#') ? scrollTarget : '#' + scrollTarget;
        setTimeout(() => {
            scrollToElement(selector, 200);
        }, 300);
    }
});

$(document).ready(function () {
    const selectorButton = document.querySelector('.selector-custom__selected');
    const dropdown = document.querySelector('.selector-custom__dropdown');

    if (dropdown && selectorButton) {
        const selectedIcon = selectorButton.querySelector('.selector-custom__icon');
        const selectedText = selectorButton.querySelector('.selector-custom__text');
        const radioInput = selectorButton.querySelector('input[type="radio"]');

        if (selectedIcon && selectedText && radioInput) {
            dropdown.addEventListener('click', function (event) {
                const option = event.target.closest('li');

                if (option) {
                    const iconUrl = option.getAttribute('data-icon');
                    const text = option.getAttribute('data-value');

                    // Устанавливаем данные в выбранный элемент
                    if (iconUrl && text) {
                        selectedIcon.src = iconUrl;
                        selectedIcon.alt = text;
                        selectedText.textContent = text;
                        radioInput.value = text;

                        // Убираем активный класс у всех элементов и добавляем текущему
                        dropdown.querySelectorAll('li').forEach(li => li.classList.remove('uk-active'));
                        option.classList.add('uk-active');

                        // Закрываем дропдаун
                        UIkit.dropdown(dropdown).hide();
                    }
                }
            });
        }
    }

    //большой слайдер с каруселью
    var thumbsProductSlider = new Swiper(".thumbsProductSlider", {
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            650: {
                slidesPerView: 5,
            },
        },
        on: {
            slideChange: function (swiper) {
                imagesLazyLoadSwiper(swiper.el);
            },
        },
    });
    var mainProductSlider = new Swiper(".mainProductSlider", {
        loop: true,
        spaceBetween: 15,
        slidesPerView: 1,
        breakpoints: {
            400: {
                spaceBetween: 20,
            },
            640: {
                slidesPerView: 1,
            },
        },
        thumbs: {
            swiper: thumbsProductSlider,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            slideChange: function (swiper) {
                imagesLazyLoadSwiper(swiper.el);
            },
        },
    });

    var availabilitySection = new Swiper(".availabilitySection", {
        autoHeight: false,
        slidesPerView: 5,  // Количество видимых слайдов
        spaceBetween: 16,  // Отступ между слайдами
        loop: true,        // Бесконечный режим
        watchSlidesProgress: true,
        lazy: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
            1324: {
                slidesPerView: 4,
            },
            1440: {
                slidesPerView: 5,
            },
        },
        navigation: {      // Настраиваем кнопки навигации
            nextEl: '.swiper-pagination--next',
            prevEl: '.swiper-pagination--prev',
        },
        pagination: {
            el: '.swiper-pagination--val',
            type: 'custom',
        },
        on: {
            init: function(swiper) {
                updateSwiperCustomPagination(swiper);
            },
            slideChange: function (swiper) {
                updateSwiperCustomPagination(swiper);
                imagesLazyLoadSwiper(swiper.el);
            },
        },
    });

    if ($(window).width() <= 1100) {
        var swiperSpecificationSection = new Swiper(".specificationSection", {
            autoHeight: true,
            slidesPerView: 5,
            spaceBetween: 16,
            loop: true,
            lazy: true,
            breakpoints: {
                320: {
                    slidesPerView: 1.3,
                },
                768: {
                    slidesPerView: 2.3,
                },
                1024: {
                    slidesPerView: 3.3,
                },
                1324: {
                    slidesPerView: 4.3,
                },
                1440: {
                    slidesPerView: 5,
                },
            },
            navigation: {
                nextEl: '.swiper-pagination--next',
                prevEl: '.swiper-pagination--prev',
            },
            pagination: {
                el: '.swiper-pagination--val',
                type: 'custom',
            },
            on: {
                init: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    imagesLazyLoadSwiper(swiper.el);
                },
            },
        });
    }

    const swipersConfig = {
        '.swiper-container-downloads' : {
            autoHeight: true,
            slidesPerView: 5,  // Количество видимых слайдов
            spaceBetween: 16,  // Отступ между слайдами
            loop: true,        // Бесконечный режим
            lazy: true,
            breakpoints: {
                320: {
                    slidesPerView: 1.3,
                },
                480: {
                    slidesPerView: 2,
                },
                800: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                },
                1440: {
                    slidesPerView: 5,
                },
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    //console.log('Активный слайд:', swiper.activeIndex);
                    imagesLazyLoadSwiper(swiper.el);
                },
            },
        },
        '.swiper-container-reviews' : {
            autoHeight: false,
            slidesPerView: 4,  // Количество видимых слайдов
            spaceBetween: 16,  // Отступ между слайдами
            loop: true,        // Бесконечный режим
            watchSlidesProgress: true,
            lazy: true,
            breakpoints: {
                320: {
                    slidesPerView: 1.3,
                },
                768: {
                    slidesPerView: 2.3,
                },
                1024: {
                    slidesPerView: 3.3,
                },
                1200: {
                    slidesPerView: 4,
                },
            },
            navigation: {      // Настраиваем кнопки навигации
                nextEl: '.swiper-pagination--next',
                prevEl: '.swiper-pagination--prev',
            },
            pagination: {
                el: '.swiper-pagination--val',
                type: 'custom',
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    imagesLazyLoadSwiper(swiper.el);
                },
            },
        },
        '.swiper-reviews-photo' : {
            autoHeight: false,
            slidesPerView: 9,  // Количество видимых слайдов
            spaceBetween: 8,  // Отступ между слайдами
            loop: true,        // Бесконечный режим
            watchSlidesProgress: true,
            lazy: true,
            breakpoints: {
                320: {
                    slidesPerView: 1.3,
                },
                768: {
                    slidesPerView: 2.3,
                },
                1024: {
                    slidesPerView: 3.3,
                },
                1200: {
                    slidesPerView: 4,
                },
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    imagesLazyLoadSwiper(swiper.el);
                },
            },
        },
        '.swiper-container-5' : {
            autoHeight: false,
            slidesPerView: 5,  // Количество видимых слайдов
            spaceBetween: 16,  // Отступ между слайдами
            loop: true,        // Бесконечный режим
            watchSlidesProgress: true,
            lazy: true,
            breakpoints: {
                320: {
                    slidesPerView: 1.3,
                },
                768: {
                    slidesPerView: 2.3,
                },
                1024: {
                    slidesPerView: 3.3,
                },
                1324: {
                    slidesPerView: 4.3,
                },
                1440: {
                    slidesPerView: 5,
                },
            },
            navigation: {      // Настраиваем кнопки навигации
                nextEl: '.swiper-pagination--next',
                prevEl: '.swiper-pagination--prev',
            },
            pagination: {
                el: '.swiper-pagination--val',
                type: 'custom',
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    imagesLazyLoadSwiper(swiper.el);
                },
            },
        },
        '.swiper-container-5-new' : {
            autoHeight: false,
            slidesPerView: 5,  // Количество видимых слайдов
            spaceBetween: 16,  // Отступ между слайдами
            loop: true,        // Бесконечный режим
            watchSlidesProgress: true,
            a11y: {
                enabled: true,
                slideRole: 'listitem', // Добавление правильной роли для слайдов
                containerRole: 'region', // Роль для контейнера
                prevSlideMessage: 'Предыдущий слайд',
                nextSlideMessage: 'Следующий слайд',
            },
            lazy: true,
            breakpoints: {
                320: {
                    slidesPerView: 1.3,
                },
                768: {
                    slidesPerView: 2.3,
                },
                1024: {
                    slidesPerView: 3.3,
                },
                1324: {
                    slidesPerView: 4.3,
                },
                1440: {
                    slidesPerView: 5,
                },
            },
            navigation: {      // Настраиваем кнопки навигации
                nextEl: '.swiper-pagination--next',
                prevEl: '.swiper-pagination--prev',
            },
            pagination: {
                el: '.swiper-pagination--val',
                type: 'custom',
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                    //console.log('инициализация');
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    imagesLazyLoadSwiper(swiper.el);
                    //console.log('переключение');
                },
            },
        },
        '.swiper-container-5-view' : {
            autoHeight: false,
            slidesPerView: 5,  // Количество видимых слайдов
            spaceBetween: 16,  // Отступ между слайдами
            loop: true,        // Бесконечный режим
            watchSlidesProgress: true,
            lazy: {
                enabled: false,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.3,
                },
                768: {
                    slidesPerView: 2.3,
                },
                1024: {
                    slidesPerView: 3.3,
                },
                1324: {
                    slidesPerView: 4.3,
                },
                1440: {
                    slidesPerView: 5,
                },
            },
            navigation: {      // Настраиваем кнопки навигации
                nextEl: '.swiper-pagination--next',
                prevEl: '.swiper-pagination--prev',
            },
            pagination: {
                el: '.swiper-pagination--val',
                type: 'custom',
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    //console.log('Активный слайд:', swiper.activeIndex);
                    imagesLazyLoadSwiper(swiper.el);
                },
            },
        },
        '.partners-banners' : {
            autoHeight: true,
            slidesPerView: 1,
            spaceBetween: 0,
            watchSlidesProgress: true,
            loop: true,
            autoplay: false,
            lazy: {
                enabled: false,
            },
            navigation: {
                nextEl: '.swiper-pagination--next',
                prevEl: '.swiper-pagination--prev',
            },
            pagination: {
                el: '.swiper-pagination--val',
                type: 'custom',
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    //console.log('Активный слайд:', swiper.activeIndex);
                    imagesLazyLoadSwiper(swiper.el);
                },
            },
        },
    };

    const initSwiper = (selector, config) => {
        // Инициализируем Swiper без вызова swiper.lazy.load()
        const swiper = new Swiper(selector, config);
    };

    // инициализирую ток если слайдер попадает в область видимости
    const observerOptions = {
        root: null,
        rootMargin: '50px',
        threshold: 0.1
    };

    const swiperObservers = {};

    Object.keys(swipersConfig).forEach(selector => {
        const element = document.querySelector(selector);
        if (element) {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        //console.log(`Инициализирую Swiper для: ${selector}`);
                        initSwiper(selector, swipersConfig[selector]);
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(element);
        } else {
            console.log(`Селектор ${selector} не найден на странице.`);
        }
    });

    function updateSwiperCustomPagination(swiper, paginatorSelector = '.swiper-pagination--val') {
        if (!swiper.slides || swiper.slides.length < 2) {
            const paginatorParent = swiper.el.querySelector(paginatorSelector)?.parentElement;
            if (paginatorParent) {
                paginatorParent.style.display = 'none';
            }
        } else {
            const current = swiper.realIndex + 1;
            const total = swiper.slides.length;
            const paginatorElement = swiper.el.querySelector(paginatorSelector);

            if (paginatorElement) {
                paginatorElement.parentElement.style.display = 'flex';
                paginatorElement.innerText = `${current} / ${total}`;
            }
        }
    }

    window.updateSwiperCustomPagination = updateSwiperCustomPagination;

// credit start
//
//     const minusBtn = document.querySelector('.popQuantity .minus');
//     const plusBtn = document.querySelector('.popQuantity .plus');
//     const input = document.querySelector('.popQuantity input');
//
//     if(minusBtn) {
//         minusBtn.addEventListener('click', function () {
//             let value = parseInt(input.value);
//             if (value > 1) {
//                 value--;
//                 input.value = value;
//                 if (value === 1) {
//                     minusBtn.classList.add('uk-disabled');
//                 }
//             }
//             renderPrice();
//         });
//     }
//
//     if(plusBtn) {
//         plusBtn.addEventListener('click', function () {
//             let value = parseInt(input.value);
//             value++;
//             input.value = value;
//             if (value > 1) {
//                 minusBtn.classList.remove('uk-disabled');
//             }
//
//             renderPrice();
//
//             // Retail rocket analytic
//             (window["rrApiOnReady"] = window["rrApiOnReady"] || []).push(function () {
//                 try {
//                     if (document.querySelector('form.ecommerce[name="credits"]')) {
//                         if (typeof document.querySelector('form.ecommerce[name="credits"]').dataset.ecom_id !== 'undefined') {
//                             const productId = document.querySelector('form.ecommerce[name="credits"]').dataset.ecom_id;
//                             rrApi.addToBasket(
//                                 parseInt(productId)
//                             );
//                         }
//                     }
//                 } catch (e) {}
//             })
//         });
//     }

    document.querySelector(".block-credit .btn-submit").addEventListener("click", function (event) {
           const form = this.closest("form");
           if (form.checkValidity()) {
               this.closest(".btn-submit").classList.add("loading");
           }
       });

    let iconSvg = '<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L5 3.58579L8.29289 0.292893C8.68342 -0.0976311 9.31658 -0.0976311 9.70711 0.292893C10.0976 0.683417 10.0976 1.31658 9.70711 1.70711L5.70711 5.70711C5.31658 6.09763 4.68342 6.09763 4.29289 5.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z" fill="#232323" /></svg>';

    // $('.additional-characteristics-button').click(function () {
    //     if ($(this).hasClass('opened')) {
    //         // Button is ON (showing all), turn it OFF - hide additional items
    //         $(this).removeClass('opened');
    //         $('.additional-characteristics').removeClass('item-toggle');
    //         $(this).html('<?= POCAZATI_VSEO ?>' + iconSvg);
    //     } else {
    //         // Button is OFF (hiding additional items), turn it ON - show all items
    //         $(this).addClass('opened');
    //         $('.additional-characteristics').addClass('item-toggle');
    //         $(this).html('<?= SKRYT ?>' + iconSvg);
    //     }
    // });
    // $('.half-characteristics-button').click(function () {
    //     if ($(this).hasClass('opened')) {
    //         $(this).removeClass('opened');
    //         $('.half-characteristics').removeClass('opened');
    //         $(this).html('<?= SKRYT ?>' + iconSvg);
    //
    //     } else {
    //         $(this).addClass('opened');
    //         $('.half-characteristics').addClass('opened');
    //         $(this).html('<?= POCAZATI_VSEO ?>' + iconSvg);
    //     }
    // });
});

(function() {
    'use strict';

    // Утилиты
    const utils = {
        getQuality: () => {
            const input = document.querySelector('.qualityProductsCredit');
            return input ? parseInt(input.value) || 1 : 1;
        },
        format: (n) => n.toLocaleString('ru-RU'),
        safeQuery: (selector, callback) => {
            const el = document.querySelector(selector);
            if (el) callback(el);
            return el;
        }
    };

    // Флаг для предотвращения двойного вызова
    let isUpdating = false;

    // Основная функция обновления цен
    window.renderPrice = function() {
        if (isUpdating) return;
        isUpdating = true;

        try {
            const quality = utils.getQuality();
            const priceEl = document.querySelector('#modal-credit .price');
            if (!priceEl) return console.warn('Price element not found');

            const oldPrice = parseInt(priceEl.dataset.priceOld) * quality;
            const newPrice = parseInt(priceEl.dataset.priceNew) * quality;

            const oldEl = priceEl.querySelector('.price-old');
            const newEl = priceEl.querySelector('.price-new');

            if (oldEl) oldEl.textContent = utils.format(oldPrice);
            if (newEl) newEl.textContent = utils.format(newPrice);


            utils.safeQuery('.product_price', el => {
                el.value = newPrice.toFixed(2);
            });

            // Обновляем все radio кнопки и их цены
            updateAllPrices(quality);
        } finally {
            isUpdating = false;
        }
    };

    // Функция обновления всех цен в списке
    function updateAllPrices(quality) {
        const items = document.querySelectorAll('#modal-credit .pop_credit_class_ul li');

        items.forEach(li => {
            const label = li.querySelector('.month_btns_y');
            const radio = li.querySelector('input[type="radio"]');
            const priceSpan = li.querySelector('.quantity-price');

            if (!label || !radio || !priceSpan) return;

            // Получаем базовую цену из data-price
            const basePrice = radio.dataset.price || parseInt(radio.value) || 0;
            const newPrice = parseInt(basePrice * quality);
            // Обновляем value радио
            radio.value = newPrice;

            // Обновляем отображение цены
            priceSpan.innerHTML = utils.format(newPrice) + ' <span class="currency">лей</span>';

            // Если радио выбрано, обновляем общую цену
            if (radio.checked) {
                updateSelectedPrice(radio, quality);
            }
        });
    }

    // Функция обновления выбранной цены
    function updateSelectedPrice(radio, quality) {
        const value = parseInt(radio.value) || 0;
        const type = radio.dataset.type || 'credit';
        const payments = radio.dataset.payments || 'платежей';

        utils.safeQuery('.price-month span', el => {
            el.textContent = utils.format(value);
        });

        utils.safeQuery('.credit_type', el => {
            el.value = type;
        });

        utils.safeQuery('.price-month .payments', el => {
            const text = el.dataset.text || 'в';
            el.textContent = text + ' ' + payments;
        });

        utils.safeQuery('.product_price', el => {
            el.value = value.toFixed(2);
        });
    }

    // Функция monthToInput
    window.monthToInput = function(item) {
        const text = item.dataset.month || item.innerText;
        utils.safeQuery('.mons', el => {
            el.value = text.replace(/\D/g, "");
        });

        const radio = item.querySelector('input[type="radio"]');
        if (!radio) return;

        // Делаем радио выбранным
        document.querySelectorAll('#modal-credit .pop_credit_class_ul input[type="radio"]').forEach(r => {
            r.checked = false;
        });
        radio.checked = true;

        // Обновляем цену при выборе
        const quality = utils.getQuality();
        const basePrice = parseInt(radio.dataset.price) || parseInt(radio.value) || 0;
        const newPrice = basePrice * quality;

        radio.value = newPrice;

        // Обновляем отображение цены
        const priceSpan = item.querySelector('.quantity-price');
        if (priceSpan) {
            priceSpan.innerHTML = utils.format(newPrice) + ' <span class="currency">лей</span>';
        }

        // Обновляем общую сумму
        updateSelectedPrice(radio, quality);

        // Убираем класс active у всех
        document.querySelectorAll('#modal-credit .month_btns_y').forEach(el => {
            el.classList.remove('uk-active', 'active');
        });
        item.classList.add('uk-active', 'active');

        renderPrice();
    };

    // Функция updatePrice
    window.updatePrice = function(value, type, id, month, placeholder, payments) {
        const quality = utils.getQuality();
        const totalPrice = parseInt(value) || 0;

        utils.safeQuery('.price-month span', el => {
            el.textContent = utils.format(totalPrice);
        });

        utils.safeQuery('.credit_type', el => {
            el.value = type;
        });

        utils.safeQuery('.price-month .payments', el => {
            const text = el.dataset.text || 'в';
            el.textContent = text + ' ' + payments;
        });

        utils.safeQuery('.product_price', el => {
            el.value = totalPrice.toFixed(2);
        });

        renderPrice();
    };

    // Инициализация кнопок + и - (только один раз)
    let buttonsInitialized = false;

    function initQuantityButtons() {
        if (buttonsInitialized) return;
        buttonsInitialized = true;

        const minusBtn = document.querySelector('.popQuantity .minus');
        const plusBtn = document.querySelector('.popQuantity .plus');
        const input = document.querySelector('.qualityProductsCredit');

        if (!input || !minusBtn || !plusBtn) return;

        // Функция обновления количества
        function updateQuantity(newValue) {
            let value = newValue;
            if (value < 1) value = 1;

            input.value = value;

            // Обновляем состояние кнопки минус
            if (value <= 1) {
                minusBtn.classList.add('uk-disabled');
            } else {
                minusBtn.classList.remove('uk-disabled');
            }

            // Пересчитываем все цены
            renderPrice();
        }

        // Обработчик для кнопки минус (только один)
        minusBtn.removeEventListener('click', minusHandler);
        minusBtn.addEventListener('click', minusHandler);

        function minusHandler() {
            const currentValue = parseInt(input.value) || 1;
            if (currentValue > 1) {
                updateQuantity(currentValue - 1);
            }
        }

        // Обработчик для кнопки плюс (только один)
        plusBtn.removeEventListener('click', plusHandler);
        plusBtn.addEventListener('click', plusHandler);

        function plusHandler() {
            const currentValue = parseInt(input.value) || 1;
            updateQuantity(currentValue + 1);
        }

        // Блокируем ручной ввод
        input.removeEventListener('input', inputHandler);
        input.addEventListener('input', inputHandler);

        function inputHandler(e) {
            const val = parseInt(this.value) || 1;
            if (val < 1) {
                this.value = 1;
            }
            renderPrice();
        }

        // Инициализация состояния кнопки минус
        if (parseInt(input.value) <= 1) {
            minusBtn.classList.add('uk-disabled');
        }
    }

    // Инициализация при открытии модалки
    if (typeof UIkit !== 'undefined' && UIkit.util) {
        UIkit.util.on('#modal-credit', 'show', function() {
            // Прокрутка вниз
            const body = document.querySelector('#modal-credit .uk-modal-body .block-scroll');
            if (body) body.scrollTop = body.scrollHeight;

            setTimeout(() => {
                initQuantityButtons();
            }, 300);
        });
    }

    // Инициализация при загрузке DOM
    document.addEventListener('DOMContentLoaded', function() {
        initQuantityButtons();
        renderPrice();
    });

    setTimeout(() => {
        const autoClickEl = document.querySelector('#modal-credit .auto-click');
        if (autoClickEl) {
            autoClickEl.click();
        }
    }, 200);

})();

document.getElementById('credit-phone')?.addEventListener('change', function(e) {
    let value = this.value.replace(/\D/g, '');
    if (value.length > 8) {
        value = value.slice(-8);
    }
    this.value = value;
    this.setAttribute('value', value);
});

$(document).on('click', function (event) {
    if (!$(event.target).closest('.label-error').length) {
        $('.label-error').hide();
    }
});

document.querySelectorAll('.share-btn').forEach(button => {
    button.addEventListener('click', function(event) {
        event.preventDefault();

        const url = this.href;
        const width = this.getAttribute('data-width') || 600;
        const height = this.getAttribute('data-height') || 400;

        const left = (screen.width - width) / 2;
        const top = (screen.height - height) / 2;

        if (url.startsWith("viber://")) {
            window.location.href = url;
        } else {
            window.open(url, 'ShareWindow', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`);
        }
    });


});
document.querySelectorAll('.select-options li')?.forEach((option) => {
    option.addEventListener('click', function () {
        const select = this.closest('.custom-select');
        const button = select.querySelector('.select-button');
        button.textContent = this.textContent;
        select.classList.remove('open');
    });
});



function toggleReviews(button) {
    const hiddenCards = document.querySelectorAll('.review-hidden-card');
    const slider = document.querySelector('.uk-slider.slider-review');
    const isHidden = hiddenCards.length > 0 && hiddenCards[0].classList.contains('uk-hidden');

    if (isHidden) {
        // Показываем
        hiddenCards.forEach(card => card.classList.remove('uk-hidden'));
        button.classList.add('hide');
        if (slider) slider.classList.add('reviews-expanded');
    } else {
        // Скрываем
        hiddenCards.forEach(card => card.classList.add('uk-hidden'));
        button.classList.remove('hide');
        if (slider) slider.classList.remove('reviews-expanded');
    }
}

document.getElementById('btnCopyCode').addEventListener('click', function() {
    const codeText = document.getElementById('copyCode').innerText;
    const alertText = document.querySelector('.copy-code').dataset.text;
    navigator.clipboard.writeText(codeText).then(() => {
        UIkit.notification(alertText + " <span class='uk-text-bold'>" + codeText + "</span>", {pos: 'top-right', status: 'success'});
    }).catch(err => {
        console.error('Ошибка копирования: ', err);
    });
});

document.getElementById("copyLink").addEventListener("click", function () {
    navigator.clipboard.writeText(window.location.href).then(() => {
        const alertText = document.querySelector('#copyLink').dataset.text;
        UIkit.notification(alertText, {pos: 'top-right', status: 'success'});
    });
});

const blocks = document.querySelectorAll('.product-viewers');

if (blocks.length > 0) {
    let count = Number(blocks[0].dataset.count);

    function render() {
        blocks.forEach((block) => {
            const isRussian = block.dataset.lang.toLowerCase() === 'ru';

            block.querySelector('.viewers-count').textContent = String(count);
            block.querySelector('.viewers-before').textContent = isRussian
                ? (count === 1 ? 'Сейчас смотрит ' : 'Сейчас смотрят ')
                : 'Este urmărit de ';
            block.querySelector('.viewers-after').textContent = isRussian
                ? ([2, 3, 4].includes(count) ? ' человека' : ' человек')
                : (count === 1 ? ' persoană' : ' persoane');
        });
    }

    render();

    setInterval(() => {
        let next;
        do {
            next = Math.floor(Math.random() * 7) + 1;
        } while (next === count);

        count = next;
        render();
    }, 30000);
}

UIkit.util.on('#conditions-credit', 'beforeshow', function () {
    const modal = document.getElementById('conditions-credit');
    const container = modal.querySelector('.conditions-content');
    const btn = document.querySelector('.btn-conditions');

    const url = btn.dataset.ajaxUrl;

    container.innerHTML = '<div class="uk-text-center uk-margin"><span uk-spinner="ratio: 1.5"></span></div>';

    fetch(url, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
        }
    })
        .then(r => {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
        })
        .then(json => {
            if (!json.success || !json.data || !json.data.text) {
                const isRo = document.documentElement.lang.toLowerCase().startsWith('ro');
                throw new Error(isRo ? 'Răspuns invalid' : 'Некорректный ответ');
            }
            container.innerHTML = decodeHtmlEntities(json.data.text);

            container.querySelectorAll('h2 strong').forEach(el => {
                el.replaceWith(...el.childNodes);
            });

            container.querySelectorAll('ul').forEach(ul => {
                ul.classList.add('uk-list', 'uk-list-bullet', 'uk-margin-small-top');
            });
        })
        .catch(err => {
            console.error('AJAX error:', err);
            const isRo = document.documentElement.lang.toLowerCase().startsWith('ro');
            container.innerHTML = isRo
                ? '<p class="uk-text-danger">Eroare la încărcarea datelor</p>'
                : '<p class="uk-text-danger">Ошибка загрузки данных</p>';
        });
});

function decodeHtmlEntities(str) {
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
}

UIkit.util.on(document, 'click', '.product-video-guide__trigger', function (e) {
    e.preventDefault();

    const { videoId, videoTitle, videoClose } = e.current.dataset;
    if (!/^[\w-]{11}$/.test(videoId)) return;

    const modal = UIkit.modal.dialog(
        '<button class="uk-modal-close-default" type="button" uk-close></button>' +
        '<div class="uk-modal-body"><div class="product-video-guide__player"></div></div>',
        { stack: true }
    );

    const iframe = document.createElement('iframe');
    iframe.title = videoTitle || 'Видеогид';
    iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&playsinline=1`;
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';

    const el = modal.$el;
    el.querySelector('.product-video-guide__player').append(iframe);
    el.classList.add('uk-flex-top', 'product-video-guide__modal');
    el.querySelector('.uk-modal-dialog').classList.add('uk-margin-auto-vertical', 'product-video-guide__dialog');
    el.querySelector('.uk-modal-close-default').setAttribute('aria-label', videoClose || 'Закрыть');

    // Останавливаем звук сразу, не дожидаясь окончания анимации закрытия
    UIkit.util.on(el, 'hide', () => iframe.removeAttribute('src'));
});

document.querySelectorAll('.product-video-guide .uk-slider').forEach(slider => {
    let startX = 0;
    let startY = 0;
    let dragged = false;

    slider.addEventListener('pointerdown', e => {
        startX = e.clientX;
        startY = e.clientY;
        dragged = false;
    }, true);

    slider.addEventListener('pointermove', e => {
        if (Math.abs(e.clientX - startX) > 8 ||
            Math.abs(e.clientY - startY) > 8) {
            dragged = true;
        }
    }, true);

    slider.addEventListener('click', e => {
        if (dragged && e.target.closest('.product-video-guide__trigger')) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        dragged = false;
    }, true);
});

/**
 * Отзывы: после входа через модалку переключаем блоки
 * «Войти в кабинет» → «Оставить отзыв» без перезагрузки страницы.
 * Слушает событие 'customer:login', которое шлёт обработчик [data-ajax-popup].
 */
(function ($) {
    // Вход начат с кнопки отзыва → после входа сразу откроем форму отзыва
    let reviewLoginPending = false;

    $(document).on('click', '[data-review-login]', function () {
        reviewLoginPending = true;
    });

    // Закрыли окно входа, не войдя, — сбрасываем флаг
    $(document).on('hidden', '#commonModal', function (e) {
        if (e.target === this) {
            reviewLoginPending = false;
        }
    });

    // <span role="button"> не реагирует на клавиатуру сам — Enter/Пробел = клик
    $(document).on('keydown', 'span.review-bonus-badge[role="button"]', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });

    /**
     * Блок в разделе «Отзывы»: гостевую часть меняем на кнопку из <template>.
     */
    function switchReviewCta() {
        document.querySelectorAll('.review-cta__guest').forEach(function (guest) {
            const tpl = guest.parentElement.querySelector('.review-cta__customer-tpl');
            if (!tpl) {
                return;
            }
            guest.replaceWith(tpl.content.cloneNode(true));
            tpl.remove();
        });
    }

    /**
     * Плашка в панели товара: <span> входа меняем на ссылку на форму отзыва.
     */
    function switchPanelBadge() {
        document.querySelectorAll('span.review-bonus-badge[data-review-login]').forEach(function (badge) {
            const link = document.createElement('a');
            link.href = '#review-modal';
            link.setAttribute('uk-toggle', '');
            link.className = badge.className;
            link.innerHTML = badge.innerHTML;

            const label = link.querySelector('.review-bonus-badge__link');
            const text = badge.getAttribute('data-customer-text');
            if (label && text && label.firstChild && label.firstChild.nodeType === Node.TEXT_NODE) {
                label.firstChild.nodeValue = text + ' ';
            }

            badge.replaceWith(link);
        });
    }

    $(document).on('customer:login', function () {
        // Формы отзыва нет в DOM (рендерится только для авторизованных) — проще перезагрузить
        if (!document.getElementById('review-modal')) {
            if (reviewLoginPending) {
                window.location.reload();
            }
            return;
        }

        switchReviewCta();
        switchPanelBadge();

        if (reviewLoginPending) {
            reviewLoginPending = false;
            // Модалка входа закроется автоматически: UIkit не держит две модалки без stack
            UIkit.modal('#review-modal').show();
        }
    });
})(jQuery);

(() => {
    const root = document.querySelector('.popup__quick');
    if (!root) return;

    const $ = s => root.querySelector(s);
    const form = $('form[name="quick"]'), phone = $('#qb_phone'), full = $('#quick_phone_full'),
        name = $('#quick_name'), btn = $('.qb__submit'), ckHint = $('.qb__hint--checks'),
        cks = [...root.querySelectorAll('.qb__check input')];

    const T = {
        phoneEmpty: 'Введите номер телефона',
        phoneShort: 'Номер должен содержать 8 цифр после +373',
        phoneWrong: 'Номер должен начинаться с 6, 7 или 2',
        nameShort:  'Имя должно содержать минимум 2 буквы',
        nameChars:  'Используйте только буквы',
        checks:     'Необходимо принять оба условия'
    };
    try { Object.assign(T, JSON.parse(root.dataset.i18n || '{}')); } catch (e) {}

    /* ---------- телефон: +373 XX XXX XXX ---------- */
    const digits = v => {
        let d = v.replace(/\D/g, '');
        if (d.length > 8 && d.startsWith('373')) d = d.slice(3); // +373...
        return d.replace(/^0/, '').slice(0, 8);                   // 069...
    };
    const fmt = d => [d.slice(0, 2), d.slice(2, 5), d.slice(5)].filter(Boolean).join(' ');

    const errorOf = el => {
        const v = el.value.trim();
        if (el === phone) {
            const d = digits(v);
            return !d ? T.phoneEmpty : !/^[267]/.test(d) ? T.phoneWrong : d.length < 8 ? T.phoneShort : '';
        }
        return !v ? '' : !/^[\p{L}\s'’-]+$/u.test(v) ? T.nameChars
            : v.replace(/[^\p{L}]/gu, '').length < 2 ? T.nameShort : '';
    };

    // err: null — нейтрально, '' — ок, текст — ошибка
    const setState = (el, err, shake) => {
        const f = el.closest('.qb__field'), hint = f.querySelector('.qb__hint');
        f.classList.toggle('qb-err', !!err);
        f.classList.toggle('qb-ok', err === '');
        hint.textContent = err || hint.dataset.default || '';
        if (err && shake) { f.classList.remove('shake'); void f.offsetWidth; f.classList.add('shake'); }
        return !err;
    };
    // пустое имя — нейтрально (необязательное), пустой телефон — ошибка
    const check = (el, shake) => setState(el, el === phone || el.value.trim() ? errorOf(el) : null, shake);

    phone.addEventListener('input', () => {
        const d = digits(phone.value);
        phone.value = fmt(d);
        full.value = d && '+373' + d;
        const live = d && (d.length === 8 || !/^[267]/.test(d) || phone.closest('.qb-err'));
        setState(phone, live ? errorOf(phone) : null);
    });
    phone.addEventListener('keydown', e => {
        if (e.key && e.key.length === 1 && !e.ctrlKey && !e.metaKey && /\D/.test(e.key)) e.preventDefault();
    });
    name.addEventListener('input', () => {
        if (!name.value.trim() || name.closest('.qb-ok, .qb-err')) check(name);
    });
    [phone, name].forEach(el => el.addEventListener('blur', () => el.value.trim() && check(el)));

    /* ---------- согласия ---------- */
    const checksOk = show => {
        const ok = cks.every(c => c.checked);
        cks.forEach(c => {
            const l = c.closest('.qb__check');
            l.classList.toggle('qb-err', !c.checked && (show || l.classList.contains('qb-err')));
        });
        if (show || ok) {
            ckHint.textContent = ok ? '' : T.checks;
            ckHint.classList.toggle('is-error', !ok);
        }
        return ok;
    };
    const toggleBtn = () => { btn.disabled = !checksOk(false); };
    cks.forEach(c => c.addEventListener('change', toggleBtn));

    /* ---------- отправка (capture — раньше ajax-обработчика сайта) ---------- */
    form.addEventListener('submit', e => {
        const d = digits(phone.value);
        full.value = d && '+373' + d;
        if (![check(phone, true), check(name, true), checksOk(true)].every(Boolean)) {
            e.preventDefault();
            e.stopImmediatePropagation();
            const bad = root.querySelector('.qb__field.qb-err input');
            if (bad) bad.focus();
            return;
        }
        btn.classList.add('is-loading');
        setTimeout(() => btn.classList.remove('is-loading'), 4000);
    }, true);

    /* ---------- открытие/закрытие: блокировка скролла ---------- */
    const html = document.documentElement, body = document.body;
    let opened = false, y = 0;
    const sync = () => {
        // popup is opened by main.js adding .popup__open - don't rely on computed styles, style.css loads async
        const now = root.classList.contains('popup__open');
        if (now === opened) return;
        opened = now;
        if (now) {
            y = window.scrollY;
            body.style.top = -y + 'px';
            html.classList.add('qb-lock');
            if (!phone.value && matchMedia('(min-width:600px)').matches)
                setTimeout(() => phone.focus({ preventScroll: true }), 150);
        } else {
            html.classList.remove('qb-lock');
            body.style.top = '';
            html.style.scrollBehavior = 'auto';
            window.scrollTo(0, y);
            html.style.scrollBehavior = '';
        }
    };
    const mo = new MutationObserver(sync);
    [root, root.parentElement, body].forEach(el => el && mo.observe(el, { attributes: true, attributeFilter: ['class', 'style'] }));

    sync();
    toggleBtn();
})();